import { BrowserRouter as Router } from "react-router-dom";

import RootRoute from "./Routes";

function App() {
  return (
    <Router>
      <RootRoute />
    </Router>
  );
}

export default App;
